
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 10v10h14V10H5zm-2 0v10a2 2 0 002 2h14a2 2 0 002-2V10a2 2 0 00-2-2H5a2 2 0 00-2 2zM12 3a3 3 0 00-3 3v2H7V6a5 5 0 0110 0v2h-2V6a3 3 0 00-3-3z","fill":"#fff"}}),_c('path',{attrs:{"d":"M13.5 15a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z","fill":"#fff"}})])
          )
        }
      }
    